/**
 * display/hide onboarding popup
 *
 * @param {boolean} status
 * @returns {{payload: *, type: string}}
 */
export const displayOnboardingPopup = status => {
    return {
        type   : 'DISPLAY_ONBOARDING_POPUP',
        payload: status
    };
};

/**
 * load onboarding popup data
 *
 * @param data
 * @returns {{payload: string, type: string}}
 */
export const loadOnboardingPopupData = data =>{
    return {
        type   : 'LOAD_ONBOARDING_POPUP_DATA',
        payload: data
    };
}

/**
 * display toggle layer info popup action creator
 *
 * @param {object} data - {status, data:[] }
 * @returns {{payload: *, type: string}}
 */
export const displayLayerInfoPopup = data => {
    return {
        type   : 'DISPLAY_LAYER_INFO_POPUP',
        payload: data,
    };
};

/**
 * display toggle restore layer popup action creator
 *
 * @param {object} data - {status }
 * @returns {{payload: *, type: string}}
 */
export const displayRestoreLayerPopup = data => {
    return {
        type   : 'DISPLAY_RESTORE_LAYER_POPUP',
        payload: data
    };
};

/**
 * display toggle restore layer popup action creator
 *
 * @param {object} data - {status }
 * @returns {{payload: *, type: string}}
 */
export const displayGeoserverAlertPopup = data => {
    return {
        type   : 'DISPLAY_GEOSERVER_ALERT_POPUP',
        payload: data
    };
};

/**
 * display chart zoom popup
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayChartZoomPopup = data =>{
    return {
        type   : 'DISPLAY_CHART_ZOOM_POPUP',
        payload: data
    };
}

/**
 * display text zoom popup
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayTextZoomPopup = data => {
    return {
        type   : 'DISPLAY_TEXT_ZOOM_POPUP',
        payload: data
    };
}

/**
 * display utility popup
 *
 * @param data
 * @returns {{payload: *, type: string}}
 */
export const displayUtilityPopup = data => {
    return {
        type   : 'DISPLAY_UTILITY_POPUP',
        payload: data
    }
}